import React, { useEffect, useState } from 'react'
import { Typography, CircularProgress, makeStyles } from '@paintscout/ui'

export type CVLogoProps = {
  customLogoSrc?: string
  fallback?: React.ReactNode
  label?: string
}

const useStyles = makeStyles({
  root: {
    opacity: 0,
    animation: '$fadeIn 1s linear 0.2s 1 forwards'
  },
  icon: {
    fill: '#000',
    width: '100%',
    height: '100%',
    maxWidth: 200,
    maxHeight: 100,
    objectFit: 'contain' as const
  },

  '@keyframes fadeIn': {
    '0%': {
      opacity: 0
    },
    '100%': {
      opacity: 1
    }
  }
})

function CVLogo({ customLogoSrc, fallback, label, ...props }: CVLogoProps) {
  const [useFallback, setUseFallback] = useState(true)
  const classes = useStyles(props)

  useEffect(() => {
    try {
      const testImg = new window.Image()
      testImg.onload = () => {
        setUseFallback(false)
      }
      testImg.src = customLogoSrc
    } catch {
      // fall back to the default logo below
    }
  }, [])

  return (
    <div className={classes.root} style={{ position: 'relative' }} {...props}>
      {customLogoSrc ? (
        useFallback ? (
          fallback ?? <CircularProgress size={50} />
        ) : (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column'
            }}
          >
            <img src={customLogoSrc} className={classes.icon} />
            {label && (
              <Typography style={{ marginTop: 16 }} variant={'h3'}>
                {label}
              </Typography>
            )}
          </div>
        )
      ) : (
        <CircularProgress size={50} />
      )}
    </div>
  )
}

export default CVLogo
